module.exports = __webpack_public_path__ + "img/icon_LG.9be0f9ed.jpg";